import React, { Component, createContext } from "react";
import { getPathnameWithoutRegion } from "../utils";

const defaultState = {
  pagePath: "/",
};

export const PageContext = createContext(defaultState);

export class PageContextProvider extends Component {
  render() {
    const { pathname, footerMenus, latestPosts, children } = this.props;

    return (
      <PageContext.Provider
        value={{
          pagePath: getPathnameWithoutRegion(pathname),
          footerMenus,
          latestPosts,
        }}
      >
        {children}
      </PageContext.Provider>
    );
  }
}
